import React from 'react';
import { 
Alert,
Box,
Card,
CardContent,
Typography,
Divider,
useTheme,
useMediaQuery,
keyframes,
styled, 
Button
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

// Animation for the lock icon
const lockAnimation = keyframes`
0% { transform: translateY(0) rotate(0deg); }
25% { transform: translateY(-5px) rotate(-5deg); }
50% { transform: translateY(0) rotate(0deg); }
75% { transform: translateY(-5px) rotate(5deg); }
100% { transform: translateY(0) rotate(0deg); }
`;

const StyledAlert = styled(Alert)(({ theme }) => ({
borderRadius: theme.shape.borderRadius * 2,
padding: theme.spacing(3),
boxShadow: theme.shadows[3],
transition: 'all 0.3s ease',
'&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[6],
},
}));

const AnimatedLockIcon = styled(LockIcon)(({ theme }) => ({
fontSize: 60,
color: theme.palette.error.main,
marginBottom: theme.spacing(2),
animation: `${lockAnimation} 2s ease infinite`,
}));

const LockedTab = () => {
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const navigate = useNavigate();

const handleGoBack = () => {
    navigate(-1); // Go back to previous page
};

return (
    <Box
    sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        p: isMobile ? 2 : 4,
    }}
    >
    <Card
        sx={{
        maxWidth: 600,
        width: '100%',
        borderRadius: theme.shape.borderRadius * 3,
        boxShadow: theme.shadows[10],
        overflow: 'visible',
        }}
    >
        <CardContent>
        <Box
            sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            p: isMobile ? 2 : 4,
            }}
        >
            <AnimatedLockIcon />
            
            <Typography 
            variant="h4" 
            component="h1"
            gutterBottom
            sx={{
                fontWeight: 700,
                color: theme.palette.error.main,
                fontSize: isMobile ? '1.5rem' : '2rem',
            }}
            >
            Tab Locked!
            </Typography>
            
            <StyledAlert severity="error" sx={{ width: '100%', mb: 3 }}>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Complete all previous tabs with the required inputs to unlock this section.
            </Typography>
            </StyledAlert>
            
            <Divider sx={{ width: '100%', my: 2 }} />
            
            <Typography 
            variant="body1" 
            sx={{ 
                mb: 3,
                color: theme.palette.text.secondary,
            }}
            >
            This tab will become active after you complete all the previous steps.
            </Typography>
            
            <Button
            variant="contained"
            color="primary"
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
            sx={{
                borderRadius: theme.shape.borderRadius * 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontSize: isMobile ? '0.875rem' : '1rem',
            }}
            >
            Return to Previous Tab
            </Button>
        </Box>
        </CardContent>
    </Card>
    </Box>
);
};

export default LockedTab;